export const mapErrors = (form, data) =>
  form.setFields(
    Object.keys(data).map((k) => ({
      name: k,
      errors: Array.isArray(data[k]) ? data[k] : [data[k]],
    }))
  );
